import './busy.less';

export function busy(el: HTMLElement | undefined | null) {
    if (!el) { return; }
    el.classList.add('busy');
}

export function ready(el: HTMLElement | undefined | null) {
    if (!el) { return; }
    el.classList.remove('busy');
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./Frontend/src/animations/busy.ts